module.exports = __webpack_public_path__ + "assets/preview_loop_grid.96fcaeaf.svg";